<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <template v-slot:activator="{ on }">
      <permission-tooltip
        :permission="hasPermission('calendar')"
        :tooltip="{ right: true, bottom: false, attach: false }"
      >
        <icon-button
          v-if="hasPermission('calendar')"
          v-on="on"
          icon="settings"
          color="primary"
          cls="mr-0 ml-0"
          @click="open"
          :tooltip="{ bottom: true, attach: true }"
        >
          {{ 'app.calendar.settings' | trans }}
        </icon-button>
        <icon-button v-else icon="settings" color="#dcdcdc" cls="mr-0 ml-0" :tooltip="{ bottom: true, attach: true }">
          {{ 'app.calendar.settings' | trans }}
        </icon-button>
      </permission-tooltip>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'app.calendar.settings' | trans }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text style="height: 500px; overflow-y: auto">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs11>
              <h5>{{ 'app.calendar.labels' | trans }}</h5>
            </v-flex>
            <v-flex xs1>
              <icon-button icon="add" color="success" @click="add">
                {{ 'app.add' | trans }}
              </icon-button>
            </v-flex>
            <v-flex xs12>
              <calendar-label
                v-for="label in labels"
                :key="label.id"
                :id="label.id"
                :name="label.name"
                :color="label.color"
                @deleteLabel="deleteLabel($event)"
                @updateLabel="updateLabel($event)"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { trans } from '../../app';
import { mapActions, mapGetters } from 'vuex';
import { isNumber } from 'lodash';
import axios from 'axios';

export default {
  data: function () {
    return {
      dialog: false,
      valid: false,
      loading: false,
      actions: {
        addOrUpdate: [],
        delete: [],
      },
      settings: {
        view: null,
      },
      labels: [],
    };
  },
  methods: {
    ...mapActions(['fetchCalendarLabels', 'fetchCalendarSetting', 'fetchCalendarEvents']),
    open() {
      this.fetchCalendarLabels();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.actions = {
        addOrUpdate: [],
        delete: [],
      };
      this.labels = this.calendarLabels.map((cL) => ({ ...cL }));
      this.loading = false;
    },
    async save() {
      this.loading = true;

      try {
        const addLabels = this.actions.addOrUpdate
          .filter((label) => isNumber(label.id) === false)
          .map((label) => ({
            name: label.name,
            color: label.color,
          }));
        const updateLabels = this.actions.addOrUpdate.filter((label) => isNumber(label.id));

        if (addLabels.length > 0) {
          await axios.post('/v2/labels', { labels: addLabels });
        }

        if (updateLabels.length > 0) {
          for (let i = 0; i < updateLabels.length; i++) {
            const label = updateLabels[i];
            await axios.patch(`/v2/labels/${label.id}`, {
              name: label.name,
              color: label.color,
            });
          }
        }

        if (this.actions.delete.length > 0) {
          for (let i = 0; i < this.actions.delete.length; i++) {
            const id = this.actions.delete[i];
            await axios.delete(`/v2/labels/${id}`);
          }
        }
        this.$toast.success(trans('app.actions.saved', { name: trans('app.pages.settings.index').toLowerCase() }));
      } catch (e) {
        this.$toast.error(trans('app.error_occurred'));
      }

      await this.fetchCalendarSetting();
      await this.fetchCalendarLabels();
      await this.fetchCalendarEvents();
      this.close();
    },
    add() {
      this.labels.push({
        id: uuid4(),
        name: '',
        color: 'red',
      });
    },
    deleteLabel(event) {
      this.$confirmDanger(
          trans('app.calendar.label_confirm_removal', {name: event.label.name}),
          trans('app.calendar.label_remove')
      ).then(() => {
        if (isNumber(event.label.id)) {
          this.actions.delete.push(event.label.id);
        }
        this.labels = this.labels.filter((label) => label.id !== event.label.id);
        this.actions.addOrUpdate = this.actions.addOrUpdate.filter((label) => label.id !== event.label.id);
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    },
    updateLabel(event) {
      const label = this.actions.addOrUpdate.find((label) => label.id === event.label.id);

      if (label === undefined) {
        this.actions.addOrUpdate.push(event.label);
      } else {
        label.name = event.label.name;
        label.color = event.label.color;
      }
    },
  },
  computed: {
    ...mapGetters(['calendarSetting', 'calendarLabels', 'USER', 'hasPermission']),
    rules: function () {
      return {
        content: [
          (v) => !!v || trans('app.validation.required'),
          (v) => (v && v.length >= 1) || trans('app.notes_in_patient_panel.validation.content.min', { min: '1' }),
          (v) => (v && v.length <= 5000) || trans('app.notes_in_patient_panel.validation.content.max', { max: '5000' }),
        ],
        created_at: [(v) => !!v || trans('validation.required', { attribute: trans('app.date') })],
      };
    },
  },
  watch: {
    calendarLabels: function () {
      this.labels = this.calendarLabels.map((cL) => ({ ...cL }));
    },
  },
};
</script>
